import React, { useEffect, useState } from "react";
import "./features.css";
import { Link } from "react-router-dom";
import Layout from '../layout'
import mac from "../../assets/images/home/mac.png";
import macb from "../../assets/images/home/macb.png";
import playstation from "../../assets/images/home/playstation.png";
import { useTranslation } from "react-i18next";
import { cmsInstance } from '../../axios/axiosconfig';
import { NotificationManager } from "react-notifications";


const Features = () => {
    const { t, i18n } = useTranslation();
    const [content, setContent] = useState({});

    const getContent = async () => {
        try {
            const page = window.location.pathname.replace('/cms/', '');
            let language = i18n.language;
            const { data: { content, msg }, status } = await cmsInstance.get(`/content${page}/${language}`);
            if (status == 200) {
                setContent(content);
            } else {
                NotificationManager.error(msg, "Message", 10000);
            }
        } catch (error) {
            console.log('Error', error.message);
        }
    }

    useEffect(() => {
        getContent();
        i18n.on('languageChanged', onLanguageChanged);
    }, []);

    const onLanguageChanged = () => {
        getContent();
    }

    return (
        <Layout>

            <div className="features-section">
                <div className="container">

                    <div className="row">
                        <div className="col-md-12">
                            <div className="title-page">
                                <ul className="breadcrum">
                                    <li><Link to='/'>{content.home}</Link></li>
                                    <li>{content.features}</li>
                                </ul>
                                <h2>{content.features}</h2>

                                <p>{content.heading1} </p>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-5">
                            <div className="feature-box">
                                <h3>{content.heading2}</h3>
                                <p>{content.para1}</p>
                            </div>
                        </div>
                        <div className="col-md-2"></div>
                        <div className="col-md-5">
                            <div className="feature-box">
                                <h3>{content.para2}</h3>
                                <p>{content.para6}</p>
                            </div>
                        </div>

                        <div className="col-md-5">
                            <div className="feature-box">
                                <h3>{content.para3}</h3>
                                <p>{content.para7}</p>
                            </div>
                        </div>
                        <div className="col-md-2"></div>
                        <div className="col-md-5">
                            <div className="feature-box">
                                <h3>{content.para4}</h3>
                                <p>{content.para8}</p>
                            </div>
                        </div>

                        <div className="col-md-5">
                            <div className="feature-box">
                                <h3>{content.para5}</h3>
                                <p>{content.para9}</p>
                            </div>
                        </div>
                        <div className="col-md-2"></div>

                    </div>



                </div>
            </div>




        </Layout>



























    );
};

export default Features;